module.exports = __webpack_public_path__ + "img/9a11042b-ab43-4d51-b1a3-324212bd6ee3.93fcf14f.png";